<template>
<div class="form-group">  
  <label :for="inputId" >{{label}}</label>
  <input :name="inputId" :id="inputId" v-validate="validationRule" :value="value" 
   :class="{'input form-control': true, 'is-invalid form-control': errors.has(inputId) }" 
   @input="$emit('input', $event.target.value)" />
  <span v-show="errors.has(inputId)" class="help is-invalid">{{ errors.first(inputId) }}</span>
</div>  
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, { fastExit: false })

export default {
  inject: ['$validator'],
  props: {
    value: undefined,
    inputId: { type: String },
    label: { type: String },
    validationRule: {type: String, default: ''}
  }
}
</script>



// WEBPACK FOOTER //
// text-input.vue?148aacbf